import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export const DISMISSAL_TOAST_DURATION_MS = 10000;

interface DismissalConfirmationToastProps {
  startupName: string;
  onUndo: () => void;
  onAutoDismiss: () => void;
}

const DismissalConfirmationToast: React.FC<DismissalConfirmationToastProps> = ({
  startupName,
  onUndo,
  onAutoDismiss,
}) => {
  useEffect(() => {
    const timeoutId = window.setTimeout(onAutoDismiss, DISMISSAL_TOAST_DURATION_MS);
    return () => window.clearTimeout(timeoutId);
  }, [onAutoDismiss]);

  return createPortal(
    <div
      className="fixed bottom-8 left-1/2 z-[100000] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 pointer-events-auto sm:bottom-10"
      role="status"
      aria-live="polite"
    >
      <div className="rounded-2xl shadow-2xl px-5 py-4 flex items-center gap-5 bg-[#2a2a2a] border border-emerald-500/60">
        <p className="text-white text-base min-w-0">{startupName} removed from your feed</p>
        <button
          type="button"
          onClick={onUndo}
          className="flex-shrink-0 rounded-lg bg-emerald-600 px-4 py-2 text-base font-semibold text-white hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 focus:ring-offset-[#2a2a2a]"
        >
          Undo
        </button>
      </div>
    </div>,
    document.body
  );
};

export default DismissalConfirmationToast;
